import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Hard-deletes a saved filter owned by the current user.
 *
 * @param instance - Ky HTTP instance.
 * @param id - Saved filter id.
 * @returns OperationResult (no payload).
 */
export const deleteSavedFilter = async (instance: KyInstance, id: string) => {
  try {
    return await instance.delete<OperationResult>(formatString(Uri.savedFilters.byId, id)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
